module.exports = __webpack_public_path__ + "resources/img/img-deep-security-02-3.e9adca77cf049dc78ca86e32d05b39e5.png";